import React, {useState, useRef} from 'react'

import {AiFillCamera} from 'react-icons/ai'
import {useUploadPhoto} from '../hooks/mutations'
import { updateDevices, keyId } from '../lib/utils';
import {useStateContext} from '../context/StateContext';
import {Loading, VisDiv} from '../components';
import { successAlert, errorAlert } from '../lib/utils';
import { v4 as uuidv4, v4 } from 'uuid';
import { optimizeImage } from '../hooks/imageOptimizer';


 

const InsertPhotoSanity = ({saveSanityFn}) => 
{
    const [loading, setLoading] = useState(false);
    const [imageAsset, setImageAsset] = useState();
    const [wrongImageType, setWrongImageType] = useState(false); 
    const hiddenFileInput = React.useRef(undefined);
    const testing = false
    const {devices, sUser} = useStateContext();


  const saveImageBase64 = (file, base64, position) => {
    const doc = {
      _type: 'object',
      _key: keyId(),
      src: base64, 
      fileType: file?.type,
      fileName: file?.name,
      longitude:position?.coords?.longitude,
      latitude:position?.coords?.latitude,
      postedOn: Date.now(), 
      postedBy: { _type: 'postedBy', _ref: sUser._id }, 
      status:"ATTIVO",

    }
    //console.log("DOC IMAGE", doc)
    saveSanityFn(doc)
    //addPhoto({documentId:destination._id, arrayName:'image',doc: doc})
  }

    const {mutate: uploadPhotoAsset} = useUploadPhoto({
      onSuccess:(asset)=>{
        console.log("Photo upload successful:", asset);
        setImageAsset(asset);
        saveImage(asset);
        setLoading(false);
      },
      onError:(error)=>{
        console.error("Photo upload failed:", error);
        setLoading(false); // Ensure loading state is reset
        errorAlert("UPLOAD FOTO NON RIUSCITO: " + (error?.message || "Errore sconosciuto"));
      }
    })


const onTestClick = () =>{
   
  //console.log("array name index:", arrayNameIndex, "currentDevice", currentDevice)
}

    const handleClick = event => {
      hiddenFileInput.current.click();
    };


    const saveImage = (document) => {
      const doc = {
        _type: 'image',
        _key: keyId(),
        asset: {
            _type: 'reference',
            _ref: document?._id,
            _key: keyId()
          },
        
      }
      saveSanityFn(doc)

/*         addPhoto({documentId: destination._id, arrayName:'image',doc: doc})
        const updatedDoc = destination?.image ? {...destination, image:[...destination?.image, doc]} : {...destination, image:[doc]}
        setDestination(updatedDoc)
        if (destinationType =="nonConformity"){
            console.log("inserted photo nonConformity")
            const filteredDeviceNonConformities = deviceNonConformities.filter?.(x=>x?._id !== destination?._id)
            setDeviceNonConformities([...filteredDeviceNonConformities, updatedDoc])
          } else {
            console.log("inserted photo device")
            updateDevices(devices, setDevices, currentDevice, updatedDoc)
          } */
    }




    const deletePhoto = () => {
        //console.log("delete photo")
    }

    const uploadPhoto = async (e) => {
        let loadingSet = false;
        try {
            const selectedFile = e.target.files[0];
            
            // Check if file was actually selected
            if (!selectedFile) {
                console.log("No file selected");
                return;
            }
            
            console.log("Selected file:", {
                name: selectedFile.name,
                type: selectedFile.type,
                size: selectedFile.size,
                lastModified: selectedFile.lastModified
            });
            
            // Validate file type first
            const validTypes = ['image/png', 'image/heic', 'image/svg', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/tiff'];
            if (!validTypes.includes(selectedFile.type)) {
                setWrongImageType(true);
                errorAlert("il formato della foto non è valido");
                return;
            }

            setWrongImageType(false);
            setLoading(true);
            loadingSet = true;
            console.log("Starting photo upload process...");

            // Try to optimize image with fallback to original
            let fileToUpload = selectedFile;
            try {
                console.log("Starting image optimization...");
                const optimizedFile = await Promise.race([
                    optimizeImage(selectedFile),
                    new Promise((_, reject) => 
                        setTimeout(() => reject(new Error('Image optimization timeout after 30 seconds')), 30000)
                    )
                ]);
                
                console.log("Image optimization completed:", {
                    originalSize: selectedFile.size,
                    optimizedSize: optimizedFile.size,
                    compressionRatio: ((selectedFile.size - optimizedFile.size) / selectedFile.size * 100).toFixed(1) + '%'
                });
                
                fileToUpload = optimizedFile;
            } catch (optimizationError) {
                console.warn("Image optimization failed, using original file:", optimizationError.message);
                
                // Check if original file is too large (>10MB)
                const maxSize = 10 * 1024 * 1024; // 10MB
                if (selectedFile.size > maxSize) {
                    throw new Error(`File too large (${(selectedFile.size / 1024 / 1024).toFixed(1)}MB). Maximum size is 10MB. Please use a smaller image.`);
                }
                
                fileToUpload = selectedFile;
            }

            const asset = {fileType: "image", file: fileToUpload};
            console.log("Uploading photo to Sanity...", fileToUpload === selectedFile ? "(original)" : "(optimized)");
            uploadPhotoAsset(asset);
            
        } catch (error) {
            console.error("Error in photo upload process:", error);
            
            // Always reset loading state on error
            if (loadingSet) {
                setLoading(false);
            }
            
            // Provide specific error messages
            let errorMessage = "Errore durante il caricamento dell'immagine";
            if (error.message.includes('timeout')) {
                errorMessage = "Timeout durante l'ottimizzazione dell'immagine. Riprova con un'immagine più piccola.";
            } else if (error.message.includes('memory') || error.message.includes('canvas')) {
                errorMessage = "Errore di memoria durante l'elaborazione. Riprova con un'immagine più piccola.";
            } else if (error.message.includes('File too large')) {
                errorMessage = error.message; // Use the specific file size error message
            } else if (error.message.includes('Failed to read file')) {
                errorMessage = "Impossibile leggere il file. Riprova con un'altra immagine.";
            } else if (error.message.includes('Failed to load image')) {
                errorMessage = "Immagine corrotta o non valida. Riprova con un'altra immagine.";
            }
            
            errorAlert(errorMessage);
            
            // Clear the file input to allow retry
            if (hiddenFileInput.current) {
                hiddenFileInput.current.value = '';
            }
        }
    }

    if (loading) 
    return <Loading/>;
  return (
    <div>
      <VisDiv rules={[testing]}>
        <button onClick={onTestClick}>test</button>  
      </VisDiv>     

      <button onClick={handleClick} className='round-button-no-hover'>
        <AiFillCamera
        size={25}
        color={"white"}
        />
      </button>
      <input
        type="file"
        name="upload-image"
        ref={hiddenFileInput}
        style={{display:"none"}}
        onChange={(e)=>uploadPhoto(e)}
        className="insert-photo-button"
      />
    </div>
  )
}

export default InsertPhotoSanity
